import React, { useMemo } from 'react';
import { GeoJSON } from 'react-leaflet';

import { useRouteOverlap } from '../../../context/RouteOverlapContext';
import type { RouteOverlapLayer } from '../../../services/routeOverlap/types';

function shouldRenderLayer(layer: RouteOverlapLayer, focusedRouteId: string | null): boolean {
  if (layer.role === 'network_route') {
    return !!focusedRouteId && layer.comparisonRouteId === focusedRouteId;
  }
  if (layer.role === 'network_overlap') {
    return !focusedRouteId || layer.comparisonRouteId === focusedRouteId;
  }
  return layer.visibleByDefault;
}

const RouteOverlapMapLayers: React.FC = () => {
  const { run, selectedComparisonRouteId } = useRouteOverlap();

  const visibleLayers = useMemo(
    () =>
      (run?.layers ?? []).filter((layer) => shouldRenderLayer(layer, selectedComparisonRouteId)),
    [run, selectedComparisonRouteId],
  );

  if (!run || visibleLayers.length === 0) {
    return null;
  }

  return (
    <>
      {visibleLayers.map((layer) => (
        <GeoJSON
          key={layer.id}
          data={layer.geojson as GeoJSON.GeoJsonObject}
          style={() => ({
            color: layer.style.color,
            weight: layer.style.weight ?? 4,
            opacity: layer.style.opacity ?? 0.9,
            dashArray: layer.style.dashArray,
          })}
        />
      ))}
    </>
  );
};

export default RouteOverlapMapLayers;
